import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7f5ca660")

_pushScopeId("data-v-7f5ca660")
const _hoisted_1 = { class: "word-info-container p-m-5 kn-overflow" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "p-mr-2" }
const _hoisted_7 = { class: "p-d-flex p-flex-row p-flex-wrap" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", null, null, -1)
const _hoisted_9 = { class: "p-mr-2" }
const _hoisted_10 = { class: "p-d-flex p-flex-row p-flex-wrap" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Chip = _resolveComponent("Chip")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.selectedWordName)
      ? (_openBlock(), _createBlock(_component_Toolbar, {
          key: 0,
          class: "kn-toolbar kn-toolbar--secondary p-p-0 p-m-0 p-col-12"
        }, {
          start: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.selectedWordName), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.contentInfo && _ctx.contentInfo.CONTENT_ID)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("ul", null, [
            _createVNode("li", null, [
              _createVNode("span", null, _toDisplayString(_ctx.$t('common.name')) + ":", 1),
              _createVNode("span", null, _toDisplayString(_ctx.contentInfo.CONTENT_NM), 1)
            ]),
            _createVNode("li", null, [
              _createVNode("span", null, _toDisplayString(_ctx.$t('managers.glossary.common.code')) + ":", 1),
              _createVNode("span", null, _toDisplayString(_ctx.contentInfo.CONTENT_CD), 1)
            ]),
            _createVNode("li", null, [
              _createVNode("span", null, _toDisplayString(_ctx.$t('common.description')) + ":", 1),
              _createVNode("span", null, _toDisplayString(_ctx.contentInfo.CONTENT_DS), 1)
            ])
          ])
        ]))
      : (_ctx.contentInfo?.WORD_ID)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode("ul", null, [
              _createVNode("li", null, [
                _createVNode("span", null, _toDisplayString(_ctx.$tc('managers.glossary.common.word', 1)) + ":", 1),
                _createVNode("span", null, _toDisplayString(_ctx.contentInfo.WORD), 1)
              ]),
              _createVNode("li", null, [
                _createVNode("span", null, _toDisplayString(_ctx.$t('managers.glossary.common.status')) + ":", 1),
                (_ctx.contentInfo.STATE_NM)
                  ? (_openBlock(), _createBlock("span", _hoisted_4, _toDisplayString(_ctx.$t(_ctx.glossaryDefinitionDescriptor.translation[_ctx.contentInfo.STATE_NM])), 1))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("li", null, [
                _createVNode("span", null, _toDisplayString(_ctx.$t('managers.glossary.common.category')) + ":", 1),
                (_ctx.contentInfo.CATEGORY_NM)
                  ? (_openBlock(), _createBlock("span", _hoisted_5, _toDisplayString(_ctx.$t(_ctx.glossaryDefinitionDescriptor.translation[_ctx.contentInfo.CATEGORY_NM])), 1))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("li", null, [
                _createVNode("span", null, _toDisplayString(_ctx.$t('common.description')) + ":", 1),
                _createVNode("span", null, _toDisplayString(_ctx.contentInfo.DESCR), 1)
              ]),
              _createVNode("li", null, [
                _createVNode("span", null, _toDisplayString(_ctx.$t('managers.glossary.common.formula')) + ":", 1),
                _createVNode("span", null, _toDisplayString(_ctx.contentInfo.FORMULA), 1)
              ]),
              _createVNode("li", null, [
                _createVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('managers.glossary.common.link')) + ":", 1),
                _createVNode("div", _hoisted_7, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.contentInfo.LINK, (link, index) => {
                    return (_openBlock(), _createBlock(_component_Chip, {
                      class: "p-m-1",
                      key: index
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(link.WORD), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ])
              ]),
              _createVNode("li", null, [
                _createVNode("span", null, _toDisplayString(_ctx.$t('managers.glossary.common.attributes')) + ":", 1),
                _createVNode("ul", null, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.contentInfo.SBI_GL_WORD_ATTR, (attribute, index) => {
                    return (_openBlock(), _createBlock("li", { key: index }, [
                      _createVNode("span", null, _toDisplayString(attribute.ATTRIBUTE_NM) + ":", 1),
                      _hoisted_8,
                      _createVNode("ul", null, [
                        _createVNode("li", _hoisted_9, _toDisplayString(attribute.VALUE), 1),
                        _createVNode("div", _hoisted_10, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.contentInfo.LINK, (link, index) => {
                            return (_openBlock(), _createBlock(_component_Chip, {
                              class: "p-m-1",
                              key: index
                            }, {
                              default: _withId(() => [
                                _createTextVNode(_toDisplayString(link.WORD), 1)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
  ]))
})